// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1tmt3","empty":"ModalGraph_empty__2sqhv"};